module.exports = __webpack_public_path__ + "img/task_in_progress.611bf264.svg";